import { render, staticRenderFns } from "./fallIcon.vue?vue&type=template&id=12fd3c80&scoped=true"
import script from "./fallIcon.vue?vue&type=script&lang=js"
export * from "./fallIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fd3c80",
  null
  
)

export default component.exports